import React, { useEffect, useState } from "react";
import { Table, Button, Form, Dropdown, Nav, Navbar, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Account from "../src/Photos/Account.png";
import Logo from "../src/Photos/eximtracfinallogo.png";

import { hasAccess } from "../src/roleAccess.js";

const allPages = [
    "Dashboard Page", "Customers Page", "Category Page", "Sub - Category Page",
    "Brands Page", "Products Page", "Enquiry Page", "Order Page",
    "Customers Edit Page", "Enquriy Update Page", "Order Update Page",
    "Contact Page", "Offline Order Page", "Admin Permission Page", "Admin Management Page",
];

function AdminManagement() {

    const scrollToTop = () => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    const navigate = useNavigate();

    const [admins, setAdmins] = useState([]);
    const [editAdminId, setEditAdminId] = useState(null);
    const [editedAdmin, setEditedAdmin] = useState({ Username: "", Password: "", Roles: [] });

    const fetchAdmins = async () => {
        const res = await fetch("https://api-ft5g.onrender.com/get-all-admins");
        const data = await res.json();
        if (data.success) setAdmins(data.data);
    };

    useEffect(() => {
        fetchAdmins();
    }, []);

    const handleEdit = (admin) => {
        setEditAdminId(admin.AdminID);
        setEditedAdmin({ Username: admin.Username, Password: "", Roles: admin.Roles });
    };

    const handleCancel = () => {
        setEditAdminId(null);
        setEditedAdmin({ Username: "", Password: "", Roles: [] });
    };

    const toggleRole = (page) => {
        const roles = editedAdmin.Roles.includes(page)
            ? editedAdmin.Roles.filter(r => r !== page)
            : [...editedAdmin.Roles, page];
        setEditedAdmin(prev => ({ ...prev, Roles: roles }));
    };

    const handleUpdate = async (adminId) => {
        const res = await fetch(`https://api-ft5g.onrender.com/update-admin/${adminId}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(editedAdmin),
        });
        const data = await res.json();
        if (data.success) {
            alert("Admin updated");
            fetchAdmins();
            handleCancel();
        }
    };

    const handleDelete = async (adminId) => {
        if (window.confirm("Are you sure to delete this admin?")) {
            const res = await fetch(`https://api-ft5g.onrender.com/delete-admin/${adminId}`, { method: "DELETE" });
            const data = await res.json();
            if (data.success) {
                alert("Admin deleted");
                fetchAdmins();
            }
        }
    };

    const handleLogout = () => {
        localStorage.clear();
        // Delay navigation slightly to ensure clear completes
        setTimeout(() => {
            navigate("/AdminLogin");
        }, 100); // 100ms is usually enough
    };

    const [unauthorized, setUnauthorized] = useState(false);

    useEffect(() => {
        if (!hasAccess("Admin Permission Page")) {
            setUnauthorized(true);

            // After 5 seconds, logout and redirect
            const timer = setTimeout(() => {
                localStorage.clear();
                navigate("/AdminLogin");
            }, 3000);

            return () => clearTimeout(timer); // cleanup
        }
    }, [navigate]);

    // ✅ Show unauthorized message if no access
    if (unauthorized) {
        return (
            <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
                <h2>🚫 Access Denied</h2>
                <p>You are not authorized to view this page.<br />You will be logged out in 3 seconds...</p>
            </div>
        );
    }

    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navibar" sticky="top">
                <Container>
                    {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0"> */}
                    <Navbar.Brand href="/">
                        <img src={Logo}
                            alt="logo"
                            className="d-inline-block align-top logo" />
                    </Navbar.Brand>
                    {/* </Button> */}

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        {/* <Nav className="me-auto">
                                </Nav> */}

                        <Nav>
                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Dashboard Page") && <Nav.Link as={Link} to="/AdminDash" className="adminnavtext">Dashboard</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Customers Page") && <Nav.Link as={Link} to="/Customers" className="adminnavtext">Customers</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Category Page") && <Nav.Link as={Link} to="/Category" className="adminnavtext">Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Sub - Category Page") && <Nav.Link as={Link} to="/SubCategory" className="adminnavtext">Sub-Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Brands Page") && <Nav.Link as={Link} to="/Brands" className="adminnavtext">Brands</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Products Page") && <Nav.Link as={Link} to="/AdminProducts" className="adminnavtext">Products</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Enquiry Page") && <Nav.Link as={Link} to="/Quotations" className="adminnavtext">Enquiries</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Order Page") && <Nav.Link as={Link} to="/AdminOrder" className="adminnavtext">Orders</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Contact Page") && <Nav.Link as={Link} to="/ContactUsResponse" className="adminnavtext">Contact</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Offline Order Page") && <Nav.Link as={Link} to="/OfflineOrder" className="adminnavtext">Offline Order</Nav.Link>}
                            </Button>

                            <Dropdown>
                                <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 responsiveview" id="dropdown-basic">
                                    <img src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                                    {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                                    {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>

                    <Dropdown>
                        <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 mobileview" id="dropdown-basic">
                            <img src={Account}
                                alt="account"
                                className="d-inline-block align-top"
                            />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                            {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                            {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                </Container>
            </Navbar>

            {/* ----------------Navbar Complete---------------- */}

            <div className="container mt-4">
                <h3>Admin Management</h3>
                <Table bordered striped responsive>
                    <thead>
                        <tr>
                            <th>Username</th>
                            <th>Roles</th>
                            <th>Password (New)</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {admins.map((admin) => (
                            <tr key={admin.AdminID}>
                                <td>
                                    {editAdminId === admin.AdminID ? (
                                        <Form.Control
                                            value={editedAdmin.Username}
                                            onChange={(e) => setEditedAdmin({ ...editedAdmin, Username: e.target.value })}
                                        />
                                    ) : (
                                        admin.Username
                                    )}
                                </td>

                                <td>
                                    {editAdminId === admin.AdminID ? (
                                        <div className="d-flex flex-wrap">
                                            {allPages.map(page => (
                                                <Form.Check
                                                    key={page}
                                                    type="checkbox"
                                                    label={page}
                                                    checked={editedAdmin.Roles.includes(page)}
                                                    onChange={() => toggleRole(page)}
                                                    className="me-2"
                                                />
                                            ))}
                                        </div>
                                    ) : (
                                        admin.Roles.join(", ")
                                    )}
                                </td>

                                <td>
                                    {editAdminId === admin.AdminID ? (
                                        <Form.Control
                                            type="password"
                                            value={editedAdmin.Password}
                                            onChange={(e) => setEditedAdmin({ ...editedAdmin, Password: e.target.value })}
                                            placeholder="New Password"
                                        />
                                    ) : (
                                        "••••••"
                                    )}
                                </td>

                                <td>
                                    {editAdminId === admin.AdminID ? (
                                        <>
                                            <Button variant="success" className="mt-2" onClick={() => handleUpdate(admin.AdminID)}>Save</Button>{" "}
                                            <Button variant="secondary" className="mt-2" onClick={handleCancel}>Cancel</Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button variant="primary" className="mt-2" onClick={() => handleEdit(admin)}>Edit</Button>{" "}
                                            <Button variant="danger" className="mt-2" onClick={() => handleDelete(admin.AdminID)}>Delete</Button>
                                        </>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </>
    );
}

export default AdminManagement;